<header class="landing-inversores__header">
  <div class="landing-inversores__container landing-inversores__header-inner">
    <landing-inversores-logo></landing-inversores-logo>
    <a
      class="landing-inversores__button landing-inversores__button--small landing-inversores__button--primary landing-inversores__header-cta"
      [href]="advisoryBookingUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      Reserva tu Asesoría Gratuita
    </a>
  </div>
</header>
